module.exports = __webpack_public_path__ + "static/img/ecard-sky.eee8db3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/ecard-sky.png
// module id = UCZs
// module chunks = 0